<section class="workspace-surface examples">
  @for (referenceWorkspace of referenceWorkspaces(); track referenceWorkspace.name) {
    <h4>{{ referenceWorkspace.name }}</h4>
    <ul>
      @for (group of referenceWorkspace.groups; track group.name) {
        <li>
          <span>{{ group.name }}: </span>
          @for (element of group.elements; track element.id; let last = $last) {
            <a href="{{ element.link }}" target="_blank" rel="noopener noreferrer">{{
              element.name
            }}</a>
            @if (!last) {
              <span>, </span>
            }
          }
        </li>
      }
    </ul>
  }
</section>
